import React, { useEffect, useRef, useState } from "react";
import {
  TooltipContainer,
  TooltipTip,
  TooltipClose,
  TooltipContent,
} from "./Tooltip.styled";
import Warning from "@material-ui/icons/ErrorOutline";

export interface TooltipI {
  delay?: number;
  position?: "bottom" | "top" | "left" | "right";
  content?: string;
  close?: boolean;
  setClose?: () => void;
  setOpen?: () => void;
  open?: boolean;
}
export const Tooltip: React.FC<TooltipI> = ({
  content,
  delay = 400,
  position = "bottom",
  children,
  close = false,
  open = false,
  setOpen,
  setClose,
}) => {
  let timeout: any;
  const reference = useRef(null);
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  const CloseSVG = () => {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 1.68724L11.6907 0.334106L6.5 5.69866L1.30929 0.334106L0 1.68724L5.19071 7.05179L0 12.4163L1.30929 13.7695L6.5 8.40492L11.6907 13.7695L13 12.4163L7.80929 7.05179L13 1.68724Z"
          fill="white"
        />
      </svg>
    );
  };

  return (
    <TooltipContainer
      onMouseLeave={!close ? hideTip : undefined}
      onClick={close ? showTip : undefined}
      onMouseEnter={!close ? showTip : undefined}
    >
      <Warning style={{ marginRight: 16, color: "#006BEE" }} />
      {children}
      {!!content && (active || open) && (
        <TooltipTip position={position} ref={reference}>
          {close && (
            <TooltipClose onClick={() => setClose && setClose()}>
              <CloseSVG />
            </TooltipClose>
          )}
          <TooltipContent>{content}</TooltipContent>
        </TooltipTip>
      )}
    </TooltipContainer>
  );
};

export default Tooltip;
